<template>
  <CtaBannerComponent
    v-if="ctaData"
    :data="ctaData"
  />
</template>

<script lang="ts" setup>
import type { PortableTextCTABanner } from '~/sanity/types';
import CtaBannerComponent from './CTABanner.vue';
import { useRefsStore } from '~/composables/refsStore';

const props = defineProps<PortableTextCTABanner>();

const { getResolvedCTABanner } = useRefsStore();

const ctaData = await getResolvedCTABanner(props.CTABanner?.reference?._ref);
</script>
